import React from "react";

const Intro = () => {
  return (
    <div className="tool__intro">
      <h4 className="tool__header">Align</h4>
      <ul className="intro__list">
        <li>We've improved the functionality of the <b>Align Items</b> section of the Align Tool!</li><br />

        <li>1. Click an item to select or hold shift and click to select multiple items.</li>
        <li>2. When multiple items are selected, you can click one of the selected items again to set it as the Key Element. It will be signified by a thicker border. All other selected items will align in relation to the Key Element.</li>
        <li>3. Select your preferred alignment below:</li>
        <li>- Align Items</li>
        <li>Aligns the items selected in relation to each other or the Key Element.</li>
        <li>- Align to Product</li>
        <li>All items on the canvas will align in relation to the guidelines of the product.</li>
        <li>- Align All</li>
        <li>Centers all items on the canvas based on the guidelines of the product.</li>
        {/* <li>1. Single Item Selected:</li>
        <li>- Aligns the item with the closest <b>corresponding element to the alignment action on the layer.</b> For example, align left will align item to furthest left element on the layer.</li><br />

        <li>2. Multiple Items Selected (via Shift + Click):</li>
        <li>- Aligns the selected items with the <b>closest corresponding element to the alignment action within the items in the selection.</b></li><br />

        <li>3. Multiple Items Selected with a Key Element:</li>
        <li>- Aligns all selected items based on the position of the key element in relation to the alignment action. Similar to Adobe Illustrator.</li><br />
        <li>Usage: If you <b>Shift + Click</b> to select multiple items, you can <b>regular click</b> one of the items you selected to set it as the Key Element. <b>Key Elements will receive a thicker border than the rest of the items.</b> Similar to previous two options, selected items will align in relation to the key element you've selected.</li> */}
      </ul>
    </div>
  );
};

export default Intro;
